import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import '@fontsource-variable/inter'
import { ColorModeProvider } from './theme/ColorModeContext'
import { AuthProvider } from './auth/AuthContext'
import { ToastProvider } from './components/ToastProvider'
import App from './App'
import { pushService } from './services/pushService'

// SW push-only (#61 fase 2): registrado no boot para o dispositivo JÁ inscrito
// manter o worker em dia. A inscrição em si só acontece por opt-in no menu da
// conta — registrar não pede permissão nem mostra nada.
pushService.registerServiceWorker()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 15_000,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ColorModeProvider>
        <AuthProvider>
          <BrowserRouter>
            {/* Dentro do Router: mensagens de toast podem conter RouterLink (ex.: "ver fila"). */}
            <ToastProvider>
              <App />
            </ToastProvider>
          </BrowserRouter>
        </AuthProvider>
      </ColorModeProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
